import { CalculationService } from './../calculation.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-amort-table',
  templateUrl: './amort-table.component.html',
  styleUrls: ['./amort-table.component.css']
})
export class AmortTableComponent implements OnInit {
  hide = true;
  loanAmount;
  amortizationArray = [];
  downPayment;
  downPaymentAmt;
  loanAmt;
  interestRate;
  term;
  noOfPayments;
  emi;
  totalLoanPayment;
  totalInterestPayment;

  constructor(private calcService: CalculationService) {}

  ngOnInit() {
    this.amortizationArray = this.calcService.amortizationArray;

    this.calcService.dataToEmit.subscribe(
      (dataFromForm: {
        hide: boolean, loanValue: number, downPayment: number, downPaymentAmt: number,
        loanAmount: number, interestRate: number, loanTerm: number, loanTermPayments: number,
        emi: number, totalLoanPayment: number, totalInterestPayment: number
      }) => {
        this.hide = dataFromForm.hide;
        this.loanAmount = dataFromForm.loanValue;
        this.downPayment = dataFromForm.downPayment;
        this.downPaymentAmt = dataFromForm.downPaymentAmt;
        this.loanAmt = dataFromForm.loanAmount;
        this.interestRate = dataFromForm.interestRate;
        this.term = dataFromForm.loanTerm;
        this.noOfPayments = dataFromForm.loanTermPayments;
        this.emi = dataFromForm.emi;
        this.totalLoanPayment = dataFromForm.totalLoanPayment;
        this.totalInterestPayment = dataFromForm.totalInterestPayment;
      }
    );
  }

  resetCalculation() {
    this.hide = true;
    this.loanAmount = '';
    this.downPayment = '';
    this.interestRate = '';
    this.term = '';

    this.calcService.onReceivedFormData(this.hide, this.loanAmount, this.downPayment,
      this.interestRate, this.term);

  }
}



// WEBPACK FOOTER //
// D:/IT-Projects/Projects/amortization/amortization-v03.1.1/src/app/amort-table/amort-table.component.ts